// pages/Home.js
import React from 'react';
import { useState, useEffect, useRef } from "react";
import '../pages/css/SoftwareHome.css'; // Adjust the path if necessary
import Swal from 'sweetalert2';
import homeBg from '../softwareImages/homebg.png';
import centerImage from '../softwareImages/home-center1.png';
import rightImage from '../softwareImages/videoplaybackhero.mp4'
import rightImage1 from '../softwareImages/feature-one.jpg'; // adjust path as needed
import spinnerImage from '../softwareImages/spinner.png'
import featureOne from '../softwareImages/precision.jpeg'
import featureTwo from '../softwareImages/pioneer1.jpeg'
import featureThree from '../softwareImages/transparent.jpeg'
import digitalSymbiosis from '../softwareImages/digital-symbiosis.gif'
import favIconBlue from '../softwareImages/faviconBlue.png'
import favIconYellow from '../softwareImages/faviconYellow.png'
import favIconRed from '../softwareImages/faviconRed.png'
import videobg from '../softwareImages/video-bg.jpg'
import softwareVideo from '../softwareImages/software-video.mp4'
import { ReactComponent as HtmlIcon } from '../softwareImages/icons/html.svg';
import { ReactComponent as CssIcon } from '../softwareImages/icons/css.svg';
import { ReactComponent as JsIcon } from '../softwareImages/icons/javascript.svg';
import { ReactComponent as ReactIcon } from '../softwareImages/icons/react.svg';
import { ReactComponent as NodeIcon } from '../softwareImages/icons/node-js.svg';
import { ReactComponent as AngularIcon } from '../softwareImages/icons/angular.svg';
import { ReactComponent as PhpIcon } from '../softwareImages/icons/php.svg';
import { ReactComponent as FirebaseIcon } from '../softwareImages/icons/firebase.svg';


import { motion, AnimatePresence } from "framer-motion";
import { FaArrowLeft, FaArrowRight, FaArrowDown, FaPlayCircle } from 'react-icons/fa';
import {
    BiBoltCircle,
    BiCog,
    BiBarChartAlt2,
    BiShieldAlt,
    BiRightArrowCircle
} from "react-icons/bi";
import Newsletter from './components/NewsLetter';
import Footer from './components/Footer';
import Navbar from './components/Navbar';


const Software = () => {
    const [rows, setRows] = useState([
        {
            title: "Crafting custom-built portals: Your unique digital hub",
            isHovered: false,
            showImage: false,
            targetPos: { x: 0, y: 0 },
            cursorPos: { x: 0, y: 0 },
            imageSrc: featureOne,
            imageStyle: {
                width: "30%",
                height: "auto",
                borderRadius: "12px",
                boxShadow: "0 16px 28px rgba(0, 0, 0, 0.6)",
                zIndex: 9999
            },
        },
        {
            title: "Building the Web, Beautifully and Effectively",
            isHovered: false,
            showImage: false,
            targetPos: { x: 0, y: 0 },
            cursorPos: { x: 0, y: 0 },
            imageSrc: rightImage1,
            imageStyle: {
                width: "25%",
                height: "auto",
                borderRadius: "12px",
                boxShadow: "0 8px 16px rgba(255, 99, 71, 0.5)",
            },
        },
        {
            title: "Your Mobile Vision, Expertly Crafted",
            isHovered: false,
            showImage: false,
            targetPos: { x: 0, y: 0 },
            cursorPos: { x: 0, y: 0 },
            imageSrc: featureTwo,
            imageStyle: {
                width: "25%",
                height: "auto",
                borderRadius: "12px",
                boxShadow: "0 8px 16px rgba(255, 99, 71, 0.5)",
            },
        },
        {
            title: "Minimize Risk, Maximize Quality: Our Testing Expertise",
            isHovered: false,
            showImage: false,
            targetPos: { x: 0, y: 0 },
            cursorPos: { x: 0, y: 0 },
            imageSrc: featureThree,
            imageStyle: {
                width: "25%",
                height: "auto",
                borderRadius: "12px",
                boxShadow: "0 8px 16px rgba(255, 99, 71, 0.5)",
            },
        },
    ]);

    const requestRef = useRef();

    const handleMouseEnter = (index) => {
        const updated = [...rows];
        updated[index].isHovered = true;
        setRows(updated);
    };

    const handleMouseLeave = (index) => {
        const updated = [...rows];
        updated[index].isHovered = false;
        updated[index].showImage = false;
        setRows(updated);
    };

    const handleImageEnter = (index) => {
        const updated = [...rows];
        updated[index].showImage = true;
        setRows(updated);
    };

    const handleImageLeave = (index) => {
        const updated = [...rows];
        updated[index].showImage = false;
        setRows(updated);
    };

    const handleMouseMove = (index, e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const updated = [...rows];
        updated[index].targetPos = {
            x: e.clientX - rect.left,
            y: e.clientY - rect.top,
        };
        setRows(updated);
    };

    const animate = () => {
        setRows((prevRows) =>
            prevRows.map((row) => ({
                ...row,
                cursorPos: {
                    x: row.cursorPos.x + (row.targetPos.x - row.cursorPos.x) * 0.1,
                    y: row.cursorPos.y + (row.targetPos.y - row.cursorPos.y) * 0.1,
                },
            }))
        );
        requestRef.current = requestAnimationFrame(animate);
    };

    useEffect(() => {
        requestRef.current = requestAnimationFrame(animate);
        return () => cancelAnimationFrame(requestRef.current);
    }, []);



    const handlePlayClick = () => {
        Swal.fire({
            html: `
            <div style="position: relative; padding-top: 56.25%;">
              <iframe 
                src="${softwareVideo}"
                frameborder="0" 
                allow="autoplay; encrypted-media" 
                allowfullscreen
                style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; border-radius: 10px;"
              ></iframe>
            </div>
          `,
            showCloseButton: true,
            showConfirmButton: false,
            background: 'transparent', // No white background
            customClass: {
                popup: 'video-popup-swal',
            },
            width: '70%', // Adjust width
        });
    };

    // 1. Form state and handlers
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });

    const [showModal, setShowModal] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Add your form submission logic here (e.g., API call or email service)
        console.log("Form Submitted:", formData);
        alert("Message sent successfully!");

        // Clear form and close modal
        setFormData({ name: '', email: '', subject: '', message: '' });
        setShowModal(false);
    };

    const handleOpenModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    return (
        <>

            <Navbar />

            <section
                className="herosoft-image d-flex align-items-center"
                style={{
                    backgroundImage: `url(${homeBg})`,
                    overflowX: 'hidden'
                }}
            >
                <div className="container-fluid px-4 " style={{ overflowX: 'hidden' }}>
                    <div className="row w-100 gx-0">
                        <motion.div
                            className="col-12 col-md-5 d-flex flex-column justify-content-center align-items-center herosoft-left"
                            initial={{ opacity: 0, x: -50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: false, amount: 0.5 }}
                            transition={{ duration: 1 }}
                            style={{ zIndex: 1 }}
                        >
                            <h2 className="herosoft-left-heading mb-5 text-left " style={{ marginLeft: '1rem' }}>
                                <span
                                    className="fredericka-the-great-regular "
                                    style={{ fontSize: '69px', color: '#EBBB1E', marginBottom: '0.2rem', lineHeight: '1.2' }}
                                >
                                    Crafting digital ecosystems:
                                </span>
                                <br />
                                <span
                                    className="fw-bold"
                                    style={{ fontSize: '42px', color: '#8C8370', lineHeight: '0.2' }}
                                >
                                    Where passion tints the digital landscape together.
                                </span>
                            </h2>


                            <div
                                className="d-flex justify-content-center justify-content-lg-start mt-0 mt-lg-4"
                                style={{ zIndex: 1, marginLeft: window.innerWidth >= 992 ? '22rem' : '0' }}
                            >
                                <img
                                    src={spinnerImage}
                                    alt="Rotating"
                                    className="rotating-image img-fluid" />
                            </div>

                        </motion.div>

                        <motion.div
                            className="col-12 col-md-2 herosoft-center position-relative "
                            style={{ backgroundImage: `url(${centerImage})` }}
                            initial={{ opacity: 0, scale: 0.9 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: false, amount: 0.5 }}
                            transition={{ duration: 1.2 }}
                        >
                            <div className="overlay"></div>
                        </motion.div>

                        {/* <motion.div
                            className="col-12 col-md-5 herosoft-right position-relative p-0 "
                            style={{ backgroundImage: `url(${rightImage})` }}
                            initial={{ opacity: 0, x: 50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: false, amount: 0.5 }}
                            transition={{ duration: 1.3 }}
                        >
                            <div className="overlay"></div>
                        </motion.div> */}


                        <motion.div
                            className="col-12 col-md-5 herosoft-right position-relative p-0"
                            initial={{ opacity: 0, x: 50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: false, amount: 0.5 }}
                            transition={{ duration: 1.3 }}
                        >
                            <video
                                autoPlay
                                loop
                                muted
                                playsInline
                                className="herosoft-video-bg"
                            >
                                <source src={rightImage} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                            <div className="overlay"></div>
                        </motion.div>

                        {/* <motion.div
                            className="col-12 col-md-5 herosoft-right position-relative p-0"
                            initial={{ opacity: 0, x: 50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: false, amount: 0.5 }}
                            transition={{ duration: 1.3 }}
                        >
                            <video
                                ref={videoARef}
                                autoPlay
                                muted
                                playsInline
                                className={`herosoft-video-bg ${activeVideo === 'A' ? 'active' : ''}`}
                                onTimeUpdate={handleTimeUpdate}
                                onEnded={() => handleVideoEnded('A')}
                            >
                                <source src={rightImage} type="video/mp4" />
                            </video>

                            <video
                                ref={videoBRef}
                                muted
                                playsInline
                                className={`herosoft-video-bg ${activeVideo === 'B' ? 'active' : ''}`}
                                onEnded={() => handleVideoEnded('B')}
                            >
                                <source src={rightImage} type="video/mp4" />
                            </video>

                            <div className="overlay"></div>
                        </motion.div> */}
                    </div>
                </div>
            </section>

            <motion.section className="container my-5"
                initial={{ y: 30, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: false, amount: 0.6 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
            >
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="flex-grow-1">
                        <hr className="my-line" />

                    </div>
                    <div
                        className="px-3 fw-bold fredericka-the-great-regular"
                        style={{ fontSize: '26px', color: '#545454' }}
                    >
                        Crafting with core precision and profound understanding
                    </div>
                    <div className="flex-grow-1">
                        <hr className="my-line" />
                    </div>
                </div>

                <div className="d-flex justify-content-end mt-3">
                    <span className="text-end" style={{ fontSize: '15px', color: '#ffc107' }}>
                        <i>"The only way to do great work is to love what you do." <span style={{ fontWeight: '800', color: '#545454' }}>- Steve Jobs</span></i>
                    </span>
                </div>
            </motion.section>

            <motion.section
                className="container my-5"
                initial={{ opacity: 0, y: 100 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                viewport={{ once: false, amount: 0.2 }}
            >
                <div
                    className="scroll-wrapper position-relative mx-auto"
                    style={{
                        overflowX: 'auto',
                        whiteSpace: 'wrap',
                        maxWidth: '100%',
                        paddingTop: '1rem',
                        paddingBottom: '1rem',
                    }}
                >
                    <div
                        className="scroll-track d-flex"
                        style={{
                            gap: '1rem',
                            width: '100rem',
                        }}
                    >
                        {[...Array(2)].flatMap(() => (
                            <>

                                <div
                                    className="col-6 col-sm-4 col-md-2 flex-shrink-0">
                                    <div className="box p-4 text-center rounded h-100 lobster-regular" style={{ fontSize: '25px', color: '#525452' }}>
                                        Full-stack development
                                    </div>
                                </div>
                                <div
                                    className="col-6 col-sm-4 col-md-2 flex-shrink-0">
                                    <div className="box p-4 text-center rounded h-100 lobster-regular" style={{ fontSize: '25px', color: '#BF932D' }}
                                    >
                                        Cloud migration & architecture
                                    </div>
                                </div>
                                <div
                                    className="col-6 col-sm-4 col-md-2 flex-shrink-0">
                                    <div className="box p-4 text-center rounded h-100 lobster-regular"
                                        style={{ fontSize: '25px', color: '#8DABD7' }}
                                    >
                                        Native app development
                                    </div>
                                </div>
                                <div
                                    className="col-6 col-sm-4 col-md-2 flex-shrink-0">
                                    <div className="box p-4 text-center rounded h-100 lobster-regular"
                                        style={{ fontSize: '25px', color: '#94CA51' }}
                                    >
                                        {/* Maintenance plans */}
                                        Hosting setup & management
                                    </div>
                                </div>
                                <div
                                    className="col-6 col-sm-4 col-md-2 flex-shrink-0">
                                    <div className="box p-4 text-center rounded h-100 lobster-regular"
                                        style={{ fontSize: '25px', color: '#5898CF' }}
                                    >
                                        Cross platform development
                                    </div>
                                </div>
                                <div
                                    className="col-6 col-sm-4 col-md-2 flex-shrink-0">
                                    <div className="box p-4 text-center rounded h-100 lobster-regular"
                                        style={{ fontSize: '25px', color: '#783B1F' }}
                                    >
                                        Animation & interactive elements
                                    </div>
                                </div>
                                <div
                                    className="col-6 col-sm-4 col-md-2 flex-shrink-0">
                                    <div className="box p-4 text-center rounded h-100 lobster-regular"
                                        style={{ fontSize: '25px', color: '#CDACAC' }}
                                    >
                                        Ai automated testing
                                    </div>
                                </div>


                            </>
                        ))}
                    </div>
                </div>
            </motion.section>

            <section className="container my-5">
                <div className="row g-4">
                    <div className="col-12 col-md-4">
                        <motion.div
                            className="image-box position-relative overflow-hidden rounded shadow-sm hover-trigger"
                            initial={{ opacity: 0, x: -50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.8, ease: "easeOut" }}
                            viewport={{ once: false, amount: 0.3 }}
                        >
                            <img
                                src={featureOne}
                                alt="Left"
                                className="img-fluid w-100 h-100 object-fit-cover" />
                            <div className="overlay-box position-absolute bottom-0 start-0 w-100 text-white p-3">
                                <motion.div
                                    className="icon-circle position-absolute"
                                    whileHover={{ scale: 1.2 }}
                                    transition={{ type: "spring", stiffness: 300 }}
                                >
                                    <FaArrowRight />
                                </motion.div>
                                <h5 className="mb-2">Precision. Punctuality.</h5>
                                <p className="placeholder-text m-0">These are our core values and professional ethos. Delivery with exacting accuracy and unwavering timeliness conveys a sense of control, absolute reliability and singular commitment. </p>
                            </div>
                        </motion.div>
                    </div>
                    <div className="col-12 col-md-4">
                        <motion.div
                            className="image-box position-relative overflow-hidden rounded shadow-sm hover-trigger"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8, ease: "easeOut", delay: 0.1 }}
                            viewport={{ once: false, amount: 0.3 }}
                        >
                            <img
                                src={featureTwo}
                                alt="Center"
                                className="img-fluid w-100 h-100 object-fit-cover" />
                            <div className="overlay-box position-absolute bottom-0 start-0 w-100 text-white p-3">
                                <motion.div
                                    className="icon-circle position-absolute"
                                    whileHover={{ scale: 1.2 }}
                                    transition={{ type: "spring", stiffness: 300 }}
                                >
                                    <FaArrowRight />
                                </motion.div>
                                <h5 className="mb-2">Pioneering amplification: </h5>
                                <p className="placeholder-text m-0">The genesis of code. We are architects of ultimate, transformative digital solutions. Our approach is driven by a mindset of innovation, leadership, and impactful amplification, where we don't merely develop software, but strategically expand our clients' capabilities.
                                </p>
                            </div>
                        </motion.div>
                    </div>
                    <div className="col-12 col-md-4">
                        <motion.div
                            className="image-box position-relative overflow-hidden rounded shadow-sm hover-trigger"
                            initial={{ opacity: 0, x: 50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
                            viewport={{ once: false, amount: 0.3 }}
                        >
                            <img
                                src={featureThree}
                                alt="Right"
                                className="img-fluid w-100 h-100 object-fit-cover" />
                            <div className="overlay-box position-absolute bottom-0 start-0 w-100 text-white p-3">
                                <motion.div
                                    className="icon-circle position-absolute"
                                    whileHover={{ scale: 1.2 }}
                                    transition={{ type: "spring", stiffness: 300 }}
                                >
                                    <FaArrowRight />
                                </motion.div>
                                <h5 className="mb-2">We're transparent by choice:</h5>
                                <p className="placeholder-text m-0">Transparency, a deliberate and fundamental value, not an obligation, fostering methodological and impactful communication and collaboration. This builds lasting trust and ensures alignment with your strategic objectives</p>
                            </div>
                        </motion.div>
                    </div>
                </div>
            </section>

            <br />

            <motion.section className="container my-5"
                initial={{ y: 30, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: false, amount: 0.6 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
            >
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="flex-grow-1">
                        <hr className="my-line" />

                    </div>
                    <div
                        className="px-3 fw-bold fredericka-the-great-regular"
                        style={{ fontSize: '26px', color: '#545454' }}
                    >
                        Big ideas, meticulous execution: Where precision meets play
                    </div>
                    <div className="flex-grow-1">
                        <hr className="my-line" />
                    </div>
                </div>

                <div className="d-flex justify-content-end mt-3">
                    <span className="text-end" style={{ fontSize: '15px', color: '#ffc107' }}>
                        <i>"The details are not the details. They make the design." <span style={{ fontWeight: '800', color: '#545454' }}>- Charles Eames</span></i>
                    </span>
                </div>
            </motion.section>

            <section className="container my-5">
                <div className="row">
                    <motion.div
                        className="col-12 col-md-6 mb-4"
                        initial={{ x: -100, opacity: 0 }}
                        whileInView={{ x: 0, opacity: 1 }}
                        transition={{ duration: 0.6, ease: "easeOut" }}
                        viewport={{ amount: 0.5, once: false }}
                    >
                        <div className="mx-auto" style={{ maxWidth: '1200px' }}>
                            <div className="w-100 rounded overflow-hidden" style={{ aspectRatio: '16 / 9' }}>
                                <img
                                    src={digitalSymbiosis}
                                    alt="Left Section"
                                    className="img-fluid w-100 h-100 object-fit-cover"
                                    style={{ objectFit: 'cover' }} />
                            </div>
                        </div>
                    </motion.div>
                    <motion.div
                        className="col-12 col-md-6 mb-4 d-flex align-items-center"
                        initial={{ x: 100, opacity: 0 }}
                        whileInView={{ x: 0, opacity: 1 }}
                        transition={{ duration: 0.6, ease: "easeOut", delay: 0.1 }}
                        viewport={{ amount: 0.5, once: false }}
                    >
                        <div className="p-4 bg-white rounded w-100">
                            <div className="mb-2">
                                <div
                                    className="rounded-circle bg-dark"
                                    style={{ width: "15px", height: "15px" }}
                                ></div>
                            </div>
                            <p className="text-muted mb-1" style={{ fontSize: "0.9rem" }}> Crestest Software Solutions</p>
                            <h3 className="fw-bold mb-2 fredericka-the-great-regular">Digital symbiosis: Architecting beyond code</h3>
                            <p className="text-muted mb-1" style={{ fontSize: "0.95rem" }}>
                                We resonate with your vision, forging strategically symbiotic partnerships that extend beyond code. We forge catalytic partnerships, architecting software that ignites strategic growth and fuels enduring innovation. By prioritizing scalability, we transform your digital landscape into an enduring asset. Our robust, reliable solutions transcend market fluctuations, setting new standards and propelling your business towards visionary advancement

                            </p>
                        </div>
                    </motion.div>
                </div>
            </section>

            <motion.section className="container my-5"
                initial={{ y: 30, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: false, amount: 0.6 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
            >
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="flex-grow-1">
                        <hr className="my-line" />
                    </div>
                    <div
                        className="px-3 fw-bold fredericka-the-great-regular"
                        style={{ fontSize: '23px', color: '#545454' }}
                    >
                        From pixel to platform: Imagine your dream world powered by the spectrum of digital craftsmanship
                    </div>
                    <div className="flex-grow-1">
                        <hr className="my-line" />
                    </div>
                </div>

                <div className="d-flex justify-content-end mt-3">
                    <span className="text-end" style={{ fontSize: '15px', color: '#ffc107' }}>
                        <i>"The future belongs to those who believe in the beauty of their dreams." <span style={{ fontWeight: '800', color: '#545454' }}>- Eleanor Roosevelt</span></i>
                    </span>
                </div>
            </motion.section>

            <section className="container my-5 px-3 px-sm-0">
                <div className="row g-4">
                    <div className="col-12 col-sm-6 col-lg-3">
                        <motion.div
                            initial={{ x: -100, opacity: 0 }}
                            whileInView={{ x: 0, opacity: 1 }}
                            viewport={{ once: false, amount: 0.6 }}
                            transition={{ duration: 0.6, ease: "easeOut" }}
                            className="p-4 rounded shadow-sm text-start h-100 position-relative"
                            style={{ backgroundColor: '#424256' }}
                        >
                            <div className="mb-3">
                                <BiBoltCircle size={32} className="text-primary" />
                            </div>
                            <h5 className="fw-bold mb-2 text-white">Visionary architecting: Ecosystems forged with code</h5>
                            <p className="mb-4 text-white">We build intelligent, future-ready software ecosystems.
                            </p>
                            <BiRightArrowCircle
                                size={30}
                                className="text-white hover-scale position-absolute"
                                style={{ bottom: '0.6rem', left: '1rem' }} />
                        </motion.div>
                    </div>

                    <div className="col-12 col-sm-6 col-lg-3">
                        <motion.div
                            initial={{ x: 100, opacity: 0 }}
                            whileInView={{ x: 0, opacity: 1 }}
                            viewport={{ once: false, amount: 0.6 }}
                            transition={{ duration: 0.6, ease: "easeOut", delay: 0.1 }}
                            className="p-4  rounded shadow-sm text-start h-100 position-relative"
                            style={{ backgroundColor: '#424256' }}
                        >
                            <div className="mb-3">
                                <BiCog size={32} className="text-success" />
                            </div>
                            <h5 className="fw-bold mb-2 text-white">Strategic scalability: Amplify your growth</h5>
                            <p className=" mb-4 text-white">Agile, scalable software, delivered with unwavering commitment
                                , ensures businesses thrive.
                            </p>
                            <BiRightArrowCircle
                                size={30}
                                className="hover-scale position-absolute text-white"
                                style={{ bottom: '0.6rem', left: '1rem' }} />
                        </motion.div>
                    </div>

                    <div className="col-12 col-sm-6 col-lg-3">
                        <motion.div
                            initial={{ x: -100, opacity: 0 }}
                            whileInView={{ x: 0, opacity: 1 }}
                            viewport={{ once: false, amount: 0.6 }}
                            transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
                            className="p-4   rounded shadow-sm text-start h-100 position-relative"
                            style={{ backgroundColor: '#424256' }}
                        >
                            <div className="mb-3">
                                <BiBarChartAlt2 size={32} className="text-warning" />
                            </div>
                            <h5 className="fw-bold mb-2 text-white">Meticulous accuracy: Precision and diligence</h5>
                            <p className=" mb-4 text-white">
                                Precision and diligence, implemented throughout our development process, ensure accountability.
                            </p>
                            <BiRightArrowCircle
                                size={30}
                                className="hover-scale position-absolute text-white"
                                style={{ bottom: '0.6rem', left: '1rem' }} />
                        </motion.div>
                    </div>

                    <div className="col-12 col-sm-6 col-lg-3">
                        <motion.div
                            initial={{ x: 100, opacity: 0 }}
                            whileInView={{ x: 0, opacity: 1 }}
                            viewport={{ once: false, amount: 0.7 }}
                            transition={{ duration: 0.6, ease: "easeOut", delay: 0.3 }}
                            className="p-4   rounded shadow-sm text-start h-100 position-relative"
                            style={{ backgroundColor: '#424256' }}
                        >
                            <div className="mb-3">
                                <BiShieldAlt size={32} className="text-danger" />
                            </div>
                            <h5 className="fw-bold mb-2 text-white">Transformative innovation: Software, your business catalyst.</h5>
                            <p className=" mb-4 text-white">Drive innovation and fuel growth with strategic software.
                            </p>
                            <BiRightArrowCircle
                                size={30}
                                className="hover-scale position-absolute text-white"
                                style={{ bottom: '0.6rem', left: '1rem' }} />
                        </motion.div>
                    </div>
                </div>
            </section>

            <section className="w-100 overflow-hidden py-5 bg-none">
                <motion.div className="scrolling-text text-black fw-bold mb-4">
                    <div className="d-flex align-items-center text-nowrap">
                        <img
                            src={favIconBlue}
                            className='mt-3'
                            alt="Crestest Logo"
                            style={{ width: "100px", height: "auto", marginRight: "1rem" }} />
                        <h1 className="display-1 m-0 fw-bold">
                            <span style={{
                                color: 'white',
                                WebkitTextStroke: '5px #931B1F',
                                WebkitTextFillColor: 'white',
                                fontSize: '14rem'
                            }}>
                                Crestest
                            </span>
                            <span style={{
                                color: 'white',
                                WebkitTextStroke: '5px #275E76',
                                WebkitTextFillColor: 'white',
                                fontSize: '14rem'
                            }}>
                                {' '}Softwares
                            </span>
                        </h1>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <img
                            src={favIconYellow}
                            className='mt-3'
                            alt="Crestest Logo"
                            style={{ width: "100px", height: "auto", marginRight: "1rem" }} />
                        <h1 className="display-1 m-0 fw-bold">
                            <span style={{
                                color: 'white',
                                WebkitTextStroke: '5px #931B1F',
                                WebkitTextFillColor: 'white',
                                fontSize: '14rem'
                            }}>
                                Crestest
                            </span>
                            <span style={{
                                color: 'white',
                                WebkitTextStroke: '5px #275E76',
                                WebkitTextFillColor: 'white',
                                fontSize: '14rem'
                            }}>
                                {' '}Softwares
                            </span>
                        </h1>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <img
                            src={favIconRed}
                            className='mt-3'
                            alt="Crestest Logo"
                            style={{ width: "100px", height: "auto", marginRight: "1rem" }} />
                        <h1 className="display-1 m-0 fw-bold">
                            <span style={{
                                color: 'white',
                                WebkitTextStroke: '5px #931B1F',
                                WebkitTextFillColor: 'white',
                                fontSize: '14rem'
                            }}>
                                Crestest
                            </span>
                            <span style={{
                                color: 'white',
                                WebkitTextStroke: '5px #275E76',
                                WebkitTextFillColor: 'white',
                                fontSize: '14rem'
                            }}>
                                {' '}Softwares
                            </span>
                        </h1>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                    </div>
                </motion.div>
            </section>

            <motion.section className="container my-5"
                initial={{ y: 30, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: false, amount: 0.6 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
            >
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="flex-grow-1">
                        <hr className="my-line" />

                    </div>
                    <div
                        className="px-3 fw-bold fredericka-the-great-regular"
                        style={{ fontSize: '26px', color: '#545454' }}
                    >
                        Collaboration-fueled innovation: Our featured services, seamlessly aligning with your goals
                    </div>
                    <div className="flex-grow-1">
                        <hr className="my-line" />
                    </div>
                </div>

                <div className="d-flex justify-content-end mt-3">
                    <span className="text-end" style={{ fontSize: '15px', color: '#ffc107' }}>
                        <i>“Alone we can do so little; together we can do so much.” <span style={{ fontWeight: '800', color: '#545454' }}>– Helen</span></i>
                    </span>
                </div>
            </motion.section>

            <section className="container my-4 position-relative mt-4">
                <motion.div
                    className="image-wrapper position-relative rounded overflow-hidden"
                    initial={{ x: -100, opacity: 0 }}
                    whileInView={{ x: 0, opacity: 1 }}
                    viewport={{ once: false, amount: 0.6 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                >
                    <img
                        src={videobg}
                        alt="Section Visual"
                        className="img-fluid w-100 rounded" />


                    <div
                        className="rotating-vdo-btn position-absolute"
                        style={{ bottom: '5rem', right: '8.5rem' }}
                    >
                        <img src={spinnerImage} alt="Rotating" className="rotating-video" />
                    </div>


                    <div
                        className="custom-hover-btn position-absolute"
                        style={{ bottom: '7.5rem', right: '11rem' }}
                        onClick={handlePlayClick}
                    >
                        <FaPlayCircle size={40} className="text-white" />
                    </div>
                </motion.div>
            </section>

            <motion.section className="container my-5"
                initial={{ y: 30, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: false, amount: 0.6 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
            >
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="flex-grow-1">
                        <hr className="my-line" />

                    </div>
                    <div
                        className="px-3 fw-bold fredericka-the-great-regular"
                        style={{ fontSize: '26px', color: '#545454' }}
                    >
                        Every project is a learning experience
                    </div>
                    <div className="flex-grow-1">
                        <hr className="my-line" />
                    </div>
                </div>
            </motion.section>

            <section className="container my-5">
                {rows.map((row, i) => (
                    <motion.div
                        key={i}
                        className="row mb-4 align-items-center border-top border-bottom border-4 "
                        onMouseEnter={() => handleMouseEnter(i)}
                        onMouseLeave={() => handleMouseLeave(i)}
                        style={{ cursor: "pointer", borderTop: "4px solid #ffc107", borderBottom: "4px solid #ffc107" }}
                        initial={{ opacity: 0, x: i % 2 === 0 ? -100 : 100 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6, ease: "easeOut" }}
                        viewport={{ once: false, amount: 0.6 }}
                    >
                        <div className="col-12 col-md-2 text-center p-4 bg-white rounded-start">
                            <h1
                                className="fw-bold"
                                style={{
                                    color: row.isHovered ? "#ffc107" : "#545454",
                                    transition: "color 0.4s ease",
                                }}
                            >
                                0{i + 1}
                            </h1>
                        </div>

                        <div
                            className="col-12 col-md-8 text-center p-4 bg-white position-relative"
                            onMouseMove={(e) => handleMouseMove(i, e)}
                            onMouseEnter={() => handleImageEnter(i)}
                            onMouseLeave={() => handleImageLeave(i)}
                        >

                            <h4
                                className="fw-semibold fredericka-the-great-regular"
                                style={{
                                    color: row.isHovered ? "#ffc107" : "#545454",
                                    transition: "color 0.4s ease",
                                }}
                            >
                                {row.title}
                            </h4>

                            {row.showImage && (
                                <img
                                    src={row.imageSrc}
                                    alt={`hover-img-${i}`}
                                    style={{
                                        position: "absolute",
                                        top: row.cursorPos.y,
                                        left: row.cursorPos.x,
                                        transform: "translate(-50%, -50%) rotate(15deg)",
                                        pointerEvents: "none",
                                        transition: "transform 0.1s ease-out",
                                        zIndex: 9999,
                                        ...row.imageStyle,
                                    }} />
                            )}
                        </div>

                        <div className="col-12 col-md-2 text-center p-4 bg-white rounded-end">
                            <div
                                className="d-inline-flex align-items-center justify-content-center rounded-circle p-3"
                                style={{
                                    backgroundColor: row.isHovered ? "#ffc107" : "#6c757d",
                                    transition: "background-color 0.4s ease",
                                    width: "60px",
                                    height: "60px",
                                }}
                            >
                                <div
                                    style={{
                                        transition: "opacity 0.3s ease, transform 0.3s ease",
                                        opacity: row.isHovered ? 1 : 0,
                                        transform: row.isHovered ? "translateX(0)" : "translateX(-10px)",
                                        position: "absolute",
                                    }}
                                >
                                    <FaArrowRight size={28} color="white" />
                                </div>
                                <div
                                    style={{
                                        transition: "opacity 0.3s ease, transform 0.3s ease",
                                        opacity: row.isHovered ? 0 : 1,
                                        transform: row.isHovered ? "translateY(10px)" : "translateY(0)",
                                    }}
                                >
                                    <FaArrowDown size={28} color="white" />
                                </div>
                            </div>
                        </div>
                    </motion.div>
                ))}
            </section>

            <motion.section
                className="container my-0"
                initial={{ opacity: 0, y: 100 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                viewport={{ once: false, amount: 0.2 }}
                style={{ backgroundColor: "#fff" }}
            >
                <div
                    className="scroll-wrapper position-relative mx-auto"
                    style={{
                        overflowX: 'auto',
                        whiteSpace: 'wrap',
                        maxWidth: '100%',
                    }}
                >
                    <div
                        className="scroll-track d-flex"
                        style={{
                            gap: '1rem',
                            width: '100rem',
                        }}
                    >
                        {[...Array(2)].flatMap(() => (
                            <>
                                <div className="col-6 col-sm-4 col-md-2 flex-shrink-0">
                                    <div
                                        className="box pt-3 text-center rounded h-100 lobster-regular d-flex flex-column justify-content-center align-items-center"
                                        style={{ color: "#545454" }}
                                    >
                                        <div className="d-flex align-items-center gap-2 text-black">
                                            <HtmlIcon style={{ height: '100px', width: '100px' }} />
                                            <span style={{ color: "#545454" }}>HTML</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-6 col-sm-4 col-md-2 flex-shrink-0">
                                    <div
                                        className="box pt-3 text-center rounded h-100 lobster-regular d-flex flex-column justify-content-center align-items-center"
                                        style={{ color: "#545454" }}
                                    >
                                        <div className="d-flex align-items-center gap-2 text-black">
                                            <CssIcon style={{ height: '100px', width: '100px' }} />
                                            <span style={{ color: "#545454" }}>CSS</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-6 col-sm-4 col-md-2 flex-shrink-0">
                                    <div
                                        className="box pt-3 text-center rounded h-100 lobster-regular d-flex flex-column justify-content-center align-items-center"
                                        style={{ color: "#545454" }}
                                    >
                                        <div className="d-flex align-items-center gap-2 text-black">
                                            <JsIcon style={{ height: '100px', width: '100px' }} />
                                            <span style={{ color: "#545454" }}>JavaScript</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-6 col-sm-4 col-md-2 flex-shrink-0">
                                    <div
                                        className="box pt-3 text-center rounded h-100 lobster-regular d-flex flex-column justify-content-center align-items-center"
                                        style={{ color: "#fff" }}
                                    >
                                        <div className="d-flex align-items-center gap-2 text-black">
                                            <PhpIcon style={{ height: '100px', width: '100px' }} />
                                            <span>PHP</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-6 col-sm-4 col-md-2 flex-shrink-0">
                                    <div
                                        className="box pt-3 text-center rounded h-100 lobster-regular d-flex flex-column justify-content-center align-items-center"
                                        style={{ color: "#fff" }}
                                    >
                                        <div className="d-flex align-items-center gap-2 text-black">
                                            <ReactIcon style={{ height: '100px', width: '100px' }} />
                                            <span>React</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-6 col-sm-4 col-md-2 flex-shrink-0">
                                    <div
                                        className="box pt-3 text-center rounded h-100 lobster-regular d-flex flex-column justify-content-center align-items-center"
                                        style={{ color: "#fff" }}
                                    >
                                        <div className="d-flex align-items-center gap-2 text-black">
                                            <NodeIcon style={{ height: '100px', width: '100px' }} />
                                            <span>Node.js</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-6 col-sm-4 col-md-2 flex-shrink-0">
                                    <div
                                        className="box pt-3 text-center rounded h-100 lobster-regular d-flex flex-column justify-content-center align-items-center"
                                        style={{ color: "#fff" }}
                                    >
                                        <div className="d-flex align-items-center gap-2 text-black">
                                            <FirebaseIcon style={{ height: '100px', width: '100px' }} />
                                            <span>Firebase</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-6 col-sm-4 col-md-2 flex-shrink-0">
                                    <div
                                        className="box pt-3 text-center rounded h-100 lobster-regular d-flex flex-column justify-content-center align-items-center"
                                        style={{ color: "#fff" }}
                                    >
                                        <div className="d-flex align-items-center gap-2 text-black">
                                            <AngularIcon style={{ height: '100px', width: '100px' }} />
                                            <span>Angular</span>
                                        </div>
                                    </div>
                                </div>

                            </>
                        ))}
                    </div>
                </div>
            </motion.section>


            <motion.section
                className="container my-5 d-flex flex-column align-items-center justify-content-center text-center"
                initial={{ opacity: 0, y: 100 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                viewport={{ once: false, amount: 0.2 }}
            >
                <div className="position-relative d-flex" style={{ width: '220px', height: '200px' }}>
                    <img
                        src={favIconRed}
                        alt="Centered Visual"
                        className="img-fluid rounded-circle object-fit-cover"
                        style={{ width: '170px', height: '170px', zIndex: 1, marginLeft: '-60px' }}
                    />

                    <motion.div
                        className="position-absolute d-flex align-items-center justify-content-center"
                        style={{
                            width: '170px',
                            height: '170px',
                            backgroundColor: '#ffc107',
                            borderRadius: '50%',
                            left: '100px',
                            top: 0,
                            opacity: 1,
                            transition: 'background-color 0.3s ease',
                            zIndex: 2,
                            cursor: 'pointer',
                        }}
                        onClick={handleOpenModal} // <-- Triggers the modal to open
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#275E76';
                            e.currentTarget.querySelector('.right-arrow').style.opacity = 1;
                            e.currentTarget.querySelector('.down-arrow').style.opacity = 0;
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = '#ffc107';
                            e.currentTarget.querySelector('.down-arrow').style.opacity = 1;
                            e.currentTarget.querySelector('.right-arrow').style.opacity = 0;
                        }}
                        whileHover={{ x: [0, 10, -10, 0], transition: { duration: 0.3, ease: 'easeInOut' } }}
                    >
                        <FaArrowDown
                            className="d-block down-arrow"
                            style={{
                                fontSize: '120px',
                                color: '#fff',
                                transition: 'opacity 0.3s ease',
                                opacity: 1,
                                position: 'absolute',
                            }}
                        />

                        <FaArrowRight
                            className="d-block right-arrow"
                            style={{
                                fontSize: '120px',
                                color: '#fff',
                                transition: 'opacity 0.3s ease',
                                opacity: 0,
                                position: 'absolute',
                            }}
                        />
                    </motion.div>
                </div>

                <div className="my-4" style={{ width: '60px', height: '4px', backgroundColor: '#ffc107', borderRadius: '2px' }}></div>
                <h4 className="fw-bold" style={{ color: '#545454', fontSize: '46px' }}>
                    Have any project in mind?
                </h4>
                <h4 className="fw-bold" style={{ color: '#545454', fontSize: '46px' }}>
                    Get in touch with us!
                </h4>
            </motion.section>

            {/* Bootstrap Modal Containing Your Form */}
            {showModal && (
                <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.8)' }}>
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content p-4">
                            <div className="modal-header border-0">
                                <h3 className="fw-bold" style={{ color: '#545454' }}>Get in Touch</h3>
                                <button type="button" className="btn-close" onClick={handleCloseModal}></button>
                            </div>
                            <div className="modal-body">
                                <form onSubmit={(e) => { handleSubmit(e); handleCloseModal(); }}>
                                    <div className="row g-4">

                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="form-label-custom">Your Name</label>
                                                <input
                                                    type="text"
                                                    name="name"
                                                    className="form-control custom-input-field"
                                                    placeholder="John Doe"
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="form-label-custom">Email Address</label>
                                                <input
                                                    type="email"
                                                    name="email"
                                                    className="form-control custom-input-field"
                                                    placeholder="john@example.com"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-12">
                                            <div className="form-group">
                                                <label className="form-label-custom">Subject</label>
                                                <input
                                                    type="text"
                                                    name="subject"
                                                    className="form-control custom-input-field"
                                                    placeholder="Project Inquiry / Modular Integration"
                                                    value={formData.subject}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-12">
                                            <div className="form-group">
                                                <label className="form-label-custom">Your Message</label>
                                                <textarea
                                                    name="message"
                                                    rows="5"
                                                    className="form-control custom-input-field"
                                                    placeholder="Tell us about your project requirements..."
                                                    value={formData.message}
                                                    onChange={handleChange}
                                                    required
                                                ></textarea>
                                            </div>
                                        </div>

                                        <div className="col-12 text-end">
                                            <button type="submit" className="contact-submit-btn btn btn-primary">
                                                Send Message
                                            </button>
                                        </div>

                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}




            <Newsletter />

            <Footer />

        </>
    );
};

export default Software;
